import { cva, VariantProps } from 'class-variance-authority';
import facebook from '~/assets/facebook.svg';
import google from '~/assets/google.svg';
import useTranslation from '~/i18n/i18n';
import { Button, ButtonProps } from './button';

type Provider = 'google' | 'facebook';

const socialLoginButtonVariants = cva(
  'flex h-fit w-full flex-row items-center justify-start rounded-full px-3 text-base',
  {
    variants: {
      provider: {
        google:
          'border border-black bg-white text-black dark:border-white dark:bg-black dark:text-white',
        facebook: 'bg-[#1A77F2] text-white',
      },
    },
    defaultVariants: {
      provider: 'google',
    },
  },
);

export interface SocialLoginButtonProps
  extends ButtonProps,
    VariantProps<typeof socialLoginButtonVariants> {
  provider: Provider;
}

export const SocialLoginButton = ({
  provider,
  className,
  onClick,
}: SocialLoginButtonProps) => {
  const { t } = useTranslation();

  const text = t(`auth.signIn.${provider}`);
  const icon = provider === 'google' ? google : facebook;

  return (
    <Button
      onClick={onClick}
      variant="ghost"
      className={socialLoginButtonVariants({ provider, className })}>
      <img src={icon} alt={text} className="h-5 w-5" />
      <span className="mx-5 grow">{text}</span>
    </Button>
  );
};
